import CompaniesStats from './components/CompaniesStats';
export default CompaniesStats;
